module.exports = __webpack_public_path__ + "static/img/Music.d470ef0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prizeo/imgs/browse/Music.jpg
// module id = 2089
// module chunks = 0